
        // Positive keywords: derived from the subject's other fields plus
        // light subject-type-aware extras. Returns array of suggested terms.
        function positiveSuggestions(form) {
            const out = new Set();
            const push = (s) => { if (s && s.trim()) out.add(s.trim()); };

            // Profile-derived
            push(form.family_name);
            push(form.current_employer);
            push(form.occupation);
            (form.known_locations || '').split(',').forEach(l => push(l.trim()));

            // Type-aware extras
            const t = form.subject_type_code;
            if (t === 'presenter')      ['broadcaster','presenter','TV','radio','on-air'].forEach(push);
            else if (t === 'executive') ['CEO','executive','director','chairman','board'].forEach(push);
            else if (t === 'principal') ['family','family office','heir'].forEach(push);
            else if (t === 'family_member') ['family','wife','husband','daughter','son'].forEach(push);
            else if (t === 'public_figure') ['public figure','spokesperson'].forEach(push);

            return Array.from(out);
        }

export { positiveSuggestions };
